import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { Badge } from '@material-ui/core';
import { useNotifications } from '../../hooks/useNotifications';
import { NotificationsPanel } from './NotificationsPanel';

export const NotificationsSidebarItem: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const notificationsHook = useNotifications();

  return (
    <>
      <SidebarItem
        icon={() => (
          <Badge badgeContent={notificationsHook.unreadCount} color="error">
            <NotificationsIcon />
          </Badge>
        )}
        text="Notifications"
        onClick={() => setOpen(true)}
      />
      <NotificationsPanel 
        open={open} 
        onClose={() => setOpen(false)} 
        notificationsHook={notificationsHook}
      />
    </>
  );
};

